var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-check-input",attrs:{"type":"radio"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }